import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/supply-chains/raw-items/${id}`)
                    .then((res) => {
                        resolve(res.data.data.rawItem);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create({ commit }, rawItemForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/supply-chains/raw-items", rawItemForm)
                    .then((res) => {
                        resolve(res.data.data.rawItem);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update({ commit }, rawItemForm) {
            return new Promise((resolve, reject) => {
                axios
                    .put(
                        `/supply-chains/raw-items/${rawItemForm.id}`,
                        rawItemForm
                    )
                    .then((res) => {
                        resolve(res.data.data.rawItem);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete({ commit }, rawItemId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/supply-chains/raw-items/${rawItemId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore({ commit }, rawItemId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/supply-chains/raw-items/${rawItemId}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        changeStatus({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `/supply-chains/raw-items/${params.id}/change-status`,
                        params
                    )
                    .then((res) => {
                        resolve(res.data.data.rawItem);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        syncChildren({ commit }, rawItemForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `/supply-chains/raw-items/${rawItemForm.raw_item_id}/sync-children`,
                        rawItemForm
                    )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getAddedMetaKeyLists({ commit }, rawItemId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `/supply-chains/raw-items/${rawItemId}/added-key-lists`
                    )
                    .then((res) => {
                        resolve(res.data.data.keys);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getSizes({ commit }, rawItemId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/supply-chains/raw-items/${rawItemId}/sizes`)
                    .then((res) => {
                        resolve(res.data.data.datas);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getScanData({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/supply-chains/raw-items/scan-data", {
                        params,
                    })
                    .then((res) => {
                        resolve(res.data.data.items);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        search({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/supply-chains/raw-items/search", {
                        params,
                    })
                    .then((res) => {
                        resolve(res.data.data.rawItem);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
